import store from '@/store'
export default [
  {
    path: '/admin/users',
    name: 'user',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "user" */ '@/pages/security/user')
  },
  {
    path: '/admin/users/create',
    name: 'user-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/security/user/create.vue')
  },
  {
    path: '/admin/users/:id',
    name: 'user-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/security/user/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('security/user/find', to.params.id)
      next()
    }
  }
]
